import { JsonObject, JsonProperty } from "json2typescript"
import ScheduleEntryV1 from "models/v1/ScheduleEntryV1"

export default class ClassStatsBase {
  type: "rowing" | "cycling" | "heartRate" | "workout" = undefined!

  @JsonProperty("schedule_entry", ScheduleEntryV1)
  scheduleEntry: ScheduleEntryV1 = undefined!
}
